export default "__VITE_ASSET__D$Oh8JtV__"